import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Result } from '../../shared/model/response.model';
import { StorageService } from './storage.service';
import { DataService } from "./data.service";
import { Router } from '@angular/router';
import { Category } from '../model/category.model';
import { InsertTemplateModel, Tag, UpdateTemplateModel } from '../model/tag.model';
import { HttpParams } from '@angular/common/http';
import { PaginationBaseModel } from '../components/ag-grid/ag-grid.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(public service: DataService, public router: Router, ) { }

  addCategoryService(insertCategoryModel:Category): Observable<Result> {
    let url = "smxEmailPlatform/Sendgrid/addCategory";
    const myjson = JSON.stringify(insertCategoryModel);
    console.log("add update company json........",myjson)
    return this.service.post(url, insertCategoryModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }


  addTagService(insertTagModel : Tag): Observable<Result> {
   let url = "smxEmailPlatform/Sendgrid/addsendgridtags";
   const myjson = JSON.stringify(insertTagModel);
   console.log("add update company json........",myjson)
   return this.service.post(url, insertTagModel, true).pipe <Result> (
    tap((response:any) =>{
      return response
    })
   )

  }

  getAllCategory(): Observable<Result> {
    let url = "smxEmailPlatform/Sendgrid/getallcategory";
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  getTagsByCategoryId(categoryId:string): Observable<Result> {
     let url = `smxEmailPlatform/Sendgrid/getcategoryidwisetags?Id=${categoryId}`;
     return this.service.get(url, true).pipe<Result>(
       tap((response: any) => {
         return response;
       })
     );
   }

   getTemplateById(Id:string): Observable<Result> {
    let url = `smxEmailPlatform/Sendgrid/gettemplatebyid?Id=${Id}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

   createTemplate(insertTemplateModel:InsertTemplateModel): Observable<Result> {
    let url = "smxEmailPlatform/Sendgrid/createHTMLTemplate";
    const myjson = JSON.stringify(insertTemplateModel);
    console.log("add update company json........",myjson)
    return this.service.post(url, insertTemplateModel, true).pipe <Result> (
     tap((response:any) =>{
       return response
     })
    )
 
  }

  getAllTemplateList(getAllTemplateList:PaginationBaseModel){
    let url = "smxEmailPlatform/Sendgrid/getalltemplatelist";
    return this.service.post(url, getAllTemplateList).pipe<Result>(tap((response: any) => {
    return response;
    })
    );
  }

  updateTemplate(updateTemplateModel:UpdateTemplateModel): Observable<Result> {
    let url = "smxEmailPlatform/Sendgrid/updateHTMLTemplate";
    const myjson = JSON.stringify(updateTemplateModel);
    console.log("add update company json........",myjson)
    return this.service.post(url, updateTemplateModel, true).pipe <Result> (
     tap((response:any) =>{
       return response
     })
    )
 
  }

  }

 





